<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="input-group search-holder">
          <input
            type="text"
            placeholder="Search by name, email or phone"
            @input="e => bsTerm = e.target.value"
            @keyup.enter="performBs"
            :value="bsTerm"
            class="search form-control"
          />
          <svg v-if="bsTerm" @click="resetBs" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"   width="14"
            height="14" class="close">
            <g>
              <g>
                <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                  L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                  c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                  l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                  L284.286,256.002z"/>
              </g>
            </g>
          </svg>

          <div class="input-group-append">
            <button class="btn btn-search" type="button" :disabled="!bsTerm" @click="performBs">
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 451 451"
                style="enable-background:new 0 0 451 451;"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                           s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                           C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                           s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"
                  />
                </g>
              </svg>
            </button>
              <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                <img src="@/assets/filter.svg" alt="" />
            </button>
          </div>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col-6">
            <h1>Leads</h1>
          </div>
          <!-- <div class="col-6 text-right">
            <router-link class="add-link" :to="{name: 'NewLead'}">
              <img src="../assets/add.svg" alt="" class="mr-1 mb-1" />
              Add new</router-link>
          </div> -->
        </div>
        <div class="filterTabs">
          <b-tabs content-class="mt-3">
            <b-tab v-for="(status, key) in statusesMaster"
              @click="activeStatus != `status-${status.id}` && goTo(status.id)"
              :key="`status-${status.id}-${key}`"
            >
              <template #title>
                <span class="tab-icon tab-icon-default" :class="statusClass(status)">
                </span>
                <span class="tab-title">{{status.name}}</span>
              </template>
            </b-tab>
            <div class="col-6">
              <span class="result-Text">{{pageStart}} - {{pageEnd}} of {{total}}</span>
            </div>
            <router-link v-for="(lead,key) in leads"  :key="`lead-${key}`" class="card" :to="{ name: 'Lead', params: { id: lead.uuid } }">
              <div class="card-body">
                <div class="row">
                  <div class="col-8">
                    <span class="d-block title">{{lead.name}}</span>
                    <span class="d-block sub-title" v-if="lead.assigned_to">
                      <img src="../assets/user.svg" class="mr-1 mb-1" />
                      {{lead.assigned_to}}</span>
                    <span class="d-block location">{{lead.enquiry}}</span>
                  </div>
                  <div class="col-4 text-right" v-if="lead.status_name">
                    <span class="label-status">{{lead.status_name}}</span>
                      <span class="lead-no">{{lead.lead_no}}</span>
                  </div>

                </div>
              </div>
            </router-link>
          </b-tabs>
        </div>

      </div>
          <paginate v-if="totalPages > 1"
      v-model="pageNo"
      :page-count="totalPages"
      :click-handler="goToPage"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :prev-class="'page-item'"
      :prev-link-class="'page-link'"
      :next-class="'page-item'"
      :next-link-class="'page-link'"
      :container-class="'pagination justify-content-center'"
      :page-class="'page-item'"
      :page-link-class="'page-link'">
    </paginate>
    </div>
      <!-- Right Menu Sidebar -->
        <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow fixed >
          <template v-slot="{ hide }">
          <div class="card card-form sidebar-form-card  ">
            <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
              <b-form-group>
                <b-form-input type="text" v-model="advancedFilter.name" placeholder="Name"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input type="text" v-model="advancedFilter.phone" placeholder="Mobile Number" minlength="10"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input type="email" v-model="advancedFilter.email" placeholder="Email Address"></b-form-input>
              </b-form-group>
              <b-form-group>
                  <select class="custom-select"  v-model="advancedFilter.city_id">
                  <option value="null" disabled>Select City</option>
                  <option v-for="d in cityList" :value="d.id">{{d.name}}</option>
                </select>
              </b-form-group>
               <b-form-group>
                <b-form-input type="number" v-model="advancedFilter.budget_from" placeholder="Budget From"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input type="number" v-model="advancedFilter.budget_upto" placeholder="Budget Upto"></b-form-input>
              </b-form-group>

                <b-form-group class="btn-fixed">
              <b-button variant="primary" type="submit" block @click="hide">Search</b-button>
                <b-button variant="primary-outline" block type="reset">Reset</b-button>
            </b-form-group>
            </b-form>
          </div>
          </template>
        </b-sidebar>
  </div>
</template>
<script>
  import qs from 'qs';
  import {paramsFromQuery, prepareLeadSearchParams} from '@/assets/scripts/utility.js';

  export default {
    name: "Home",
    data(){
      return {
        activeStatus: 'new',
        leads: [],
        advSearchParams: [],
        totalLeads: 0,
        perPage: 0,
        total: 0,
        bsTerm: this.$route.query.bs,
        advancedFilter: {
          name: null,
          phone: null,
          email: null,
          city_id: null,
          budget_from: null,
          budget_upto: null
        }
      }
    },
    computed: {
      cityList() {
        return this.$store.getters.cities;
      },
      statusesMaster() {
        return this.$store.getters.statusesMaster;
      },
      totalPages(){
        if(this.total === 0 || this.perPage === 0){
          return 0;
        }else{
          return Math.ceil(this.total/this.perPage);
        }
      },
      pageNo: {
        get(){
          let pageNo = this.$route.query.pageNo || 1
          return parseInt(pageNo);
        },
        set(){
          true;
        }
      },
      pageStart(){
        if(this.total === 0){
          return 0;
        }
        return (Math.max(0, (this.pageNo - 1)*this.perPage+1))
      },
      pageEnd(){
        if(this.total === 0){
          return 0;
        }
        return (Math.min(this.total, this.pageNo*this.perPage))
      }
    },
    created(){
      this.selectStatus();
    },
    watch: {
      $route(to, from){
        this.selectStatus();
      }
    },
    methods: {
      goTo(status){
        let newQ = {...this.$route.query, status_id: status}
        delete newQ['pageNo'];
        this.$router.replace({query: newQ});
      },
      selectStatus(){
        let status = this.$route.query.status_id || 1;
        let sendable;
        this.activeStatus = `status-${status}`
        sendable = status;
        this.loadData(sendable);
      },
      loadData(status){
        let queryP = {}
        if(this.$route.query.is_advanced_search){
          let searchParams = this.$route.query
          for(let key in searchParams){
            queryP[key] = searchParams[key];
          }
          this.advSearchParams = queryP
        }
        if (this.advSearchParams.length > 0){
          paramsFromQuery(queryP, this.advSearchParams, status);
        }
        else{
          paramsFromQuery(queryP, this.$route.query, status);
        }
        // paramsFromQuery(queryP, this.$route.query, status);
        this.$axios.get('leads', {
          params: queryP,
          paramsSerializer: params => qs.stringify(params, {arrayFormat: 'brackets'})
        })
        .then(res=>{
          this.leads = res.data.leads;
          this.perPage = res.data.per_page;
          this.total = res.data.count;
        })
        .catch(err => console.log(err));
      },
      goToPage(pageNo){
        let newQ = {...this.$route.query, pageNo};
        this.$router.replace({query: newQ});
      },
      AdvancedFilter() {
        let queryp = {}
        let searchParams = prepareLeadSearchParams(this.advancedFilter, this.$route.query.status_id);
        let newQ = {...searchParams, is_advanced_search: true};
        this.$router.replace({query: newQ});
      },
      resetAdvancedFilter() {
        this.advancedFilter = {}
        let rQ = this.$route.query
        if (rQ.is_advanced_search) {
          this.$router.replace({
            query: {status_id: this.$route.query.status_id}
          });
        }
      },
      resetBs(){
        let rQ = this.$route.query
        this.bsTerm = ''
        if(rQ.bs){
          let {bs, ...newQ} = rQ
          this.$router.replace({query: newQ})
        }
      },
      performBs(){
        if(this.bsTerm){
          let newQ = {...this.$route.query, bs: this.bsTerm}
          delete newQ.pageNo
          this.$router.replace({query: newQ})
        }
      },
      statusClass(status){
        if (status.name) {
          return status.name.replace(/[^A-Z0-9]/ig, '')
        }
      },
    }
  };
</script>
<style scoped>

.btn-fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 10px 20px;
  background: #fff;
  margin: 0;
}
.sidebar-form-card {
  padding: 20px 20px 100px;
}
</style>